import React from 'react'
import RightsholderRateSheetDownloadLink from '@Scenes/RightsholderScene/RightsholderRateSheetDownloadLink'
import '../index.scss'
import { RateSheetCollection } from '@Entities/statements/rate-sheet-collection'
import RateSheetTypeTooltip from '@Components/Tables/RoyaltiesTable/RatesTable/RateSheetTypeTooltip'

interface RatesTableProps {
    data: RateSheetCollection[]
    isProvisional: boolean
}

const RatesTable = ({ data, isProvisional }: RatesTableProps) => (
    <div className="royalties-table rates-table">
        <table>
            <tbody>
                <tr>
                    <th className="darkest">Usage Period</th>
                    <th className="darkest">DSP</th>
                    <th className="darkest no-right-border">
                        Rate Sheet <RateSheetTypeTooltip isProvisional={isProvisional} />{' '}
                    </th>
                </tr>
                {data.map((row: RateSheetCollection, idx: number) => {
                    const usagePeriodDate = new Date(row.year, row.month - 1, 1)
                    return (
                        <tr key={idx}>
                            <td>
                                {usagePeriodDate.toLocaleString('default', {
                                    month: 'long',
                                    year: 'numeric',
                                })}
                            </td>
                            <td className="wide-column bold">{row.dspName}</td>
                            <td className="no-right-border">
                                <div className="download-container">
                                    {row.rateSheetLinks.map((rateSheetLink, sheetIdx: number) => (
                                        <RightsholderRateSheetDownloadLink
                                            rateSheetLink={rateSheetLink}
                                            status={
                                                isProvisional
                                                    ? 'provisional'
                                                    : rateSheetLink.isOriginal
                                                      ? 'original'
                                                      : 'adjusted'
                                            }
                                            key={`rate-sheet-${sheetIdx}`}
                                        />
                                    ))}
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
)

export default RatesTable
